import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
// Wrapped route imports
import InvestorDashboard from '../../../Investor/InvestorDashboard';
import Buyback from '../../../Investor/Buyback';
import FundDetails from '../../../Investor/FundDetails';
import InvestorStatementsOld from '../../../Investor/InvestorStatementsOld';
import Managed from './Managed';
import BUYBACK_CONFIG, { isBuybackPageWindowActive } from '../../../Investor/Buyback/config';

const buybackSlug = BUYBACK_CONFIG.campaignKey
  ? `/${BUYBACK_CONFIG.campaignKey}`
  : null;

const WrappedRoutes = () => {
  const buybackEnabled = BUYBACK_CONFIG.enableFeature && isBuybackPageWindowActive();

  return (
    <div className="container__wrap" style={{ paddingTop: '30px' }}>
      <Switch>
        <Route exact path="/funds/details/:fundCode" component={FundDetails} />
        <Route exact path="/funds/statements/old" component={InvestorStatementsOld} />
        {buybackEnabled && buybackSlug && (
        <Route exact path={buybackSlug} component={Buyback} />
        )}
        <Route exact path="/" component={InvestorDashboard} />
        <Route path="/managed" component={Managed} />
        <Route>
          <Redirect to="/" />
        </Route>
      </Switch>
    </div>
  );
};

export default WrappedRoutes;
